import { Col, Row } from 'antd';
import { InverterApi } from 'api/InverterApi';
import { useAppSelector } from 'app/hooks';
import {
  selectInverterItemSidebar,
  selectSidebarList,
} from 'components/Common/Sidebar/sidebarSlice';
import InverterMenu from 'features/Inverter/components/InverterMenu/InverterMenu';
import Power from 'features/Inverter/components/Power/Power';
import Protection from 'features/Inverter/components/Protection/Protection';
import System from 'features/Inverter/components/System/System';
import { inverterInfo } from 'models';
import * as React from 'react';
import { customizeDataInverters } from 'utils/common';
import style from './Parameter.module.scss';
export interface ParameterProps {}

export default function Parameter(props: ParameterProps) {
  const plantList = useAppSelector(selectSidebarList);
  const inverterId = useAppSelector(selectInverterItemSidebar);
  const [objectInverter, setObjectInverter] = React.useState<inverterInfo>();
  const [isShowItem, setIsShowItem] = React.useState<string>('System Parameters');
  const [inverterConfig, setInverterConfig] = React.useState<any>(null);

  React.useEffect(() => {
    if (inverterId && plantList) {
      setObjectInverter(customizeDataInverters(plantList).find((item) => item.id === inverterId));
      setInverterConfig(null);
    }
  }, [inverterId, plantList]);

  React.useEffect(() => {
    if (objectInverter) {
      (async () => {
        const response: any = await InverterApi.fetchInverterConfig({
          type: objectInverter.type,
          name: 'param_setting_of_inverter',
        });
        setInverterConfig(response);
      })();
    }
  }, [objectInverter]);

  function renderSwitch(param: string) {
    switch (param) {
      case 'Power Control':
        return <Power inverterConfig={inverterConfig.power_control_panel} />;
      case 'Protection Parameters':
        return <Protection inverterConfig={inverterConfig.protection_control_panel} />;
      default:
        return <System inverterConfig={inverterConfig.system_control_panel} />;
    }
  }

  return (
    <Row align={'middle'} className={style.root}>
      <Row align={'middle'} className={style.container}>
        <Col span={7} className={style.menu_inverter}>
          <InverterMenu
            inverterConfig={inverterConfig}
            isShowItem={isShowItem}
            setIsShowItem={setIsShowItem}
            objectInverter={objectInverter}
          />
        </Col>
        <Col span={17} className={style.content}>
          {inverterConfig && renderSwitch(isShowItem)}
        </Col>
      </Row>
    </Row>
  );
}
